<template>
    <div class="customer-detail-info">
        <div v-if="superVipVisible" class="super-vip-extension">
            <div class="super-vip-header">
                <div class="super-vip-title-wrap">
                    <span class="super-vip-title">超级会员</span>
                    <el-tag :type="membershipTagType" size="mini">{{ membershipStatusText }}</el-tag>
                    <span v-if="superVip.membershipName" class="super-vip-name">{{ superVip.membershipName }}</span>
                </div>
                <el-button
                    v-if="showExtensionButton"
                    size="mini"
                    type="primary"
                    @click="openExtensionDialog">会员补偿延期</el-button>
            </div>
            <div v-if="superVip.originalEndTime" class="super-vip-meta">
                <span>最终到期：{{ superVip.originalEndTime }}</span>
                <span v-if="superVip.compensated && superVip.record">
                    本次补偿至：{{ superVip.record.newEndTime }}
                </span>
            </div>
            <el-alert
                v-if="superVip.compensated && superVip.record"
                class="super-vip-alert"
                type="success"
                :closable="false"
                show-icon
                :title="'本次洪水补偿已办理：' + superVip.record.originalEndTime + ' → ' + superVip.record.newEndTime"
                :description="'操作人：' + (superVip.record.operatorName || superVip.record.operatorId || '-') + '；操作时间：' + (superVip.record.createTime || '-') + '；备注：' + (superVip.record.remark || '-')">
            </el-alert>
            <el-alert
                v-else-if="!superVip.eligible && superVip.reason"
                class="super-vip-alert"
                type="warning"
                :closable="false"
                show-icon
                :title="superVip.reason">
            </el-alert>
            <el-alert
                v-if="contextError"
                class="super-vip-alert"
                type="error"
                :closable="false"
                show-icon
                :title="contextError">
            </el-alert>
        </div>

        <el-dialog
            title="会员补偿延期"
            :visible.sync="dialogVisible"
            width="580px"
            :close-on-click-modal="false"
            :close-on-press-escape="!submitting"
            @closed="resetExtensionForm">
            <div class="extension-dialog-context">
                <div><span class="extension-label">客户：</span>{{ customerId }}</div>
                <div><span class="extension-label">会员类型：</span>{{ superVip.membershipName || '超级会员' }}</div>
                <div><span class="extension-label">原最终到期：</span>{{ superVip.originalEndTime || '-' }}</div>
            </div>
            <el-form label-width="100px" size="small" class="extension-form">
                <el-form-item label="新到期日期" required>
                    <el-date-picker
                        v-model="extensionForm.newEndDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择新的最终到期日期"
                        style="width: 100%">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="原因备注" required>
                    <el-input
                        type="textarea"
                        v-model="extensionForm.remark"
                        :maxlength="255"
                        show-word-limit
                        :rows="3"
                        placeholder="请填写本次补偿原因（1-255字）">
                    </el-input>
                </el-form-item>
            </el-form>
            <el-alert
                title="仅调整会员到期时间，运费券请通过现有功能处理。"
                type="info"
                :closable="false"
                show-icon>
            </el-alert>
            <div v-if="extensionForm.newEndDate" class="extension-preview">
                原到期：{{ superVip.originalEndTime || '-' }} → 新到期：{{ extensionForm.newEndDate }} 23:59:59
            </div>
            <div v-if="superVip.membershipStatus === 'EXPIRED'" class="extension-expired-tip">
                该会员当前已过期，确认后立即恢复会员权益；不追补过期期间权益。
            </div>
            <span slot="footer">
                <el-button :disabled="submitting" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="submitting" @click="confirmAndSubmit">确认延期</el-button>
            </span>
        </el-dialog>

        <el-form label-width="80px" size="mini">
            <el-form-item label="订单数">
                <el-tag type="info">{{customerVip.ORDER_COUNT}}</el-tag>
            </el-form-item>
            <el-form-item label="当前等级">
                <el-tag type="info">{{customerVip.CURRENT_LEVEL_NAME}}</el-tag>
            </el-form-item>
            <el-form-item label="*修改等级" class="red">
                <el-select v-model="customerVip.CURRENT_LEVEL" placeholder="请选择" @change="updateCustomerVipLevel">
                    <el-option
                            v-for="item in levels"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="清除缓存">
                <el-button size="mini" type="danger" @click="delCustomerVipCache">清除会员缓存</el-button>
              <el-button size="mini" type="danger" @click="customerLevelUp">刷新用户等级</el-button>
            </el-form-item>
        </el-form>

      <el-tabs v-model="activeName" type="border-card"  @tab-click="initList">
        <el-tab-pane label="购买会员" name="0">
          <el-form label-width="80px" size="mini">
            <el-form-item label="*会员级别"  class="red" @change="vipProductChange">
                <el-select placeholder="请选择" v-model="bindCode"  >
                    <el-option
                            v-for="item in vipProducts"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="购买会员">
              <el-button size="mini" type="danger" @click="createVipOrder">余额购买</el-button>
            </el-form-item>
        </el-form>
        </el-tab-pane>
        <el-tab-pane label="升级日志" name="1">
          <el-table border :data="customerVip.LEVEL_LOG" size="mini">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="fromLevel" label="源等级"></el-table-column>
            <el-table-column prop="toLevel" label="目标等级"></el-table-column>
            <el-table-column prop="createTime" label="发生时间"></el-table-column>
            <el-table-column prop="orderCount" label="订单数"></el-table-column>
            <el-table-column  label="升级方式">
              <template slot-scope="scope">
                {{ formatVipLogType(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="购买日志" name="2"  >
          <el-table border :data="customerVip.LEVEL_BUY_LOG" size="mini">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="orderMainNo" label="购买单号"></el-table-column>
            <el-table-column label="购买时间">
              <template slot-scope="scope">{{ formatDateTime(scope.row.createTime) }}</template>
            </el-table-column>
            <el-table-column prop="level" label="用户等级"></el-table-column>
            <el-table-column label="开始">
              <template slot-scope="scope">{{ formatDateTime(scope.row.beginTime) }}</template>
            </el-table-column>
            <el-table-column label="结束">
              <template slot-scope="scope">{{ formatDateTime(scope.row.endTime) }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="freeStatus" label="赠品状态"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="超级会员运费券" name="3">
            <customerVipBenefit :customerId="customerId"></customerVipBenefit>
        </el-tab-pane>
        <el-tab-pane label="会员积分和明细" name="4">
            <customerPoint :customerId="customerId"></customerPoint>
        </el-tab-pane>
      </el-tabs>



    </div>
</template>
<script>
    import customerVipBenefit from './customerVipBenefit';
    import customerPoint from './customerPoint';
    import VipExtensionSubmit from '@/utils/vip-extension-submit';

    export default{
        components: {customerVipBenefit, customerPoint},
        data(){
            return {
                activeName:'0',
                superVip:{
                    loaded:false,
                    canOperate:false,
                    eligible:false,
                    membershipStatus:'NONE',
                    membershipName:'',
                    originalEndTime:'',
                    snapshotToken:'',
                    compensated:false,
                    record:null
                },
                dialogVisible:false,
                submitting:false,
                confirmOpen:false,
                contextError:'',
                extensionForm:{newEndDate:'',remark:''},
                pendingSubmit:null,
                customerGeneration:0,
                contextRequestSeq:0,
                submitVersion:0,
                vipProducts:[
                    { 
                      value:'1916723101176958976',
                      label:'典藏会员-199元年卡'
                    },
                    {
                          value:'1916722952566607873',
                        label:'醇享会员-99元季卡'
                    },
                    {
                      value:'1916722525246722048',
                      label:'鲜享会员-39元月卡'
                    }
                ],
                bindCode:'1916722525246722048',
                levels:[
                    {value:1,label:'1级会员'},
                    {value:2,label:'2级会员'},
                    {value:3,label:'3级会员'},
                    {value:4,label:'4级会员'},
                    {value:5,label:'5级会员'},
                    {value:6,label:'6级会员'},
                    {value:7,label:'7级会员'},
                    {value:20,label:'付费会员'},
                    {value:0,label:'普通用户'},
                ]
            }
        },
        props:['customerVip','customerId'],
        computed:{
            superVipVisible(){
                if(!this.superVip.loaded){
                    return false
                }
                return !!this.contextError || this.superVip.canOperate ||
                    (this.superVip.membershipStatus && this.superVip.membershipStatus !== 'NONE')
            },
            showExtensionButton(){
                return this.superVip.canOperate && this.superVip.eligible &&
                    !this.superVip.compensated && !this.submitting
            },
            membershipStatusText(){
                const map = {ACTIVE:'有效',EXPIRED:'已过期',NOT_STARTED:'未生效',NONE:'无超级会员'}
                return map[this.superVip.membershipStatus] || '无超级会员'
            },
            membershipTagType(){
                const map = {ACTIVE:'success',EXPIRED:'info',NOT_STARTED:'warning',NONE:'info'}
                return map[this.superVip.membershipStatus] || 'info'
            }
        },
        mounted(){
            this.loadSuperVipContext();
        },
        beforeDestroy(){
            this.customerGeneration += 1;
            this.contextRequestSeq += 1;
            this.submitVersion += 1;
        },
        watch:{
            customerId(){
                this.customerGeneration += 1;
                this.contextRequestSeq += 1;
                this.submitVersion += 1;
                this.pendingSubmit = null;
                this.superVip = {
                    loaded:false, canOperate:false, eligible:false, membershipStatus:'NONE',
                    membershipName:'', originalEndTime:'', snapshotToken:'', compensated:false, record:null
                };
                this.contextError = '';
                this.dialogVisible = false;
                this.resetExtensionForm();
                this.loadSuperVipContext(true);
            }
        },
        methods:{
            loadSuperVipContext(silent){
                const seq = ++this.contextRequestSeq;
                const generation = this.customerGeneration;
                const customerId = this.customerId;
                this.contextError = '';
                if(!customerId){
                    return Promise.resolve(false);
                }
                return this.$apiGet('lechun-cms/vip/extension/context',{customerId:customerId}).then(res=>{
                    if(seq !== this.contextRequestSeq || generation !== this.customerGeneration ||
                        customerId !== this.customerId){
                        return false;
                    }
                    const data = res || {};
                    this.superVip = Object.assign({loaded:true}, data);
                    return true;
                }).catch(()=>{
                    if(seq !== this.contextRequestSeq || generation !== this.customerGeneration ||
                        customerId !== this.customerId){
                        return false;
                    }
                    this.superVip = {
                        loaded:true, canOperate:false, eligible:false, membershipStatus:'NONE',
                        membershipName:'', originalEndTime:'', snapshotToken:'', compensated:false, record:null
                    };
                    this.contextError = silent ? '' : '读取会员补偿信息失败，请稍后重试';
                    return false;
                });
            },
            openExtensionDialog(){
                if(!this.superVip.eligible || this.superVip.compensated){
                    return;
                }
                this.submitVersion += 1;
                this.extensionForm = {newEndDate:'',remark:''};
                this.pendingSubmit = null;
                this.confirmOpen = false;
                this.dialogVisible = true;
            },
            resetExtensionForm(){
                this.submitVersion += 1;
                this.extensionForm = {newEndDate:'',remark:''};
                this.pendingSubmit = null;
                this.submitting = false;
                this.confirmOpen = false;
            },
            currentSubmitKey(){
                return {
                    customerId:this.customerId,
                    generation:this.customerGeneration,
                    submitVersion:this.submitVersion
                };
            },
            isCurrentSubmit(submit){
                return VipExtensionSubmit.isCurrentSubmit(submit, this.currentSubmitKey());
            },
            freezeSubmitContext(){
                const requestId = this.newRequestId();
                const payload = {
                    customerId:this.customerId,
                    newEndDate:this.extensionForm.newEndDate,
                    remark:this.extensionForm.remark,
                    snapshotToken:this.superVip.snapshotToken,
                    requestId:requestId
                };
                return VipExtensionSubmit.createSubmitContext({
                    customerId:this.customerId,
                    generation:this.customerGeneration,
                    submitVersion:this.submitVersion,
                    payload:payload
                });
            },
            confirmAndSubmit(){
                if(this.submitting || this.confirmOpen){
                    return;
                }
                const error = this.validateExtensionForm();
                if(error){
                    this.$message.warning(error);
                    return;
                }
                let submit = this.pendingSubmit;
                if(!submit || !this.isCurrentSubmit(submit) ||
                    submit.payload.newEndDate !== this.extensionForm.newEndDate ||
                    submit.payload.remark !== this.extensionForm.remark){
                    submit = this.freezeSubmitContext();
                    this.pendingSubmit = submit;
                }
                const original = this.superVip.originalEndTime || '-';
                const selected = submit.payload.newEndDate + ' 23:59:59';
                const expiredTip = this.superVip.membershipStatus === 'EXPIRED'
                    ? '该会员当前已过期，确认后立即恢复会员权益；不追补过期期间权益。'
                    : '有效会员只延长最终到期日，不会缩短原有效期。';
                const message = '原到期：' + original + ' → 新到期：' + selected + '。' +
                    expiredTip + '仅调整会员到期时间，运费券请通过现有功能处理。';
                this.confirmOpen = true;
                this.$confirm(message, '确认会员补偿延期', {
                    confirmButtonText:'确认延期',
                    cancelButtonText:'取消',
                    type:'warning',
                    closeOnClickModal:false
                }).then(()=>{
                    this.confirmOpen = false;
                    if(!this.isCurrentSubmit(submit)){
                        this.$message.warning('客户或页面状态已变化，请重新办理');
                        return;
                    }
                    this.doSubmit(submit);
                }).catch(()=>{
                    this.confirmOpen = false;
                    if(this.pendingSubmit === submit){
                        this.pendingSubmit = null;
                    }
                });
            },
            doSubmit(submit){
                if(!submit || !this.isCurrentSubmit(submit) || submit.inFlight){
                    return;
                }
                submit.inFlight = true;
                this.submitting = true;
                this.$apiPost('lechun-cms/vip/extension/submit', submit.payload).then(result=>{
                    if(!this.isCurrentSubmit(submit)){
                        return;
                    }
                    submit.inFlight = false;
                    this.submitting = false;
                    this.handleSubmitResult(result, submit);
                }).catch(err=>{
                    if(!this.isCurrentSubmit(submit)){
                        return;
                    }
                    submit.inFlight = false;
                    this.submitting = false;
                    this.handleSubmitFailure(err, submit);
                });
            },
            handleSubmitResult(result, submit){
                if(!this.isCurrentSubmit(submit)){
                    return;
                }
                const code = result && result.resultCode;
                if(code === 'SUCCESS'){
                    this.$message.success('会员延期已生效');
                    this.finishSuccess(result, submit);
                    return;
                }
                if(code === 'ALREADY_COMPENSATED'){
                    this.$message.info('该用户本次补偿已办理，不能重复办理');
                    this.finishSuccess(result, submit);
                    return;
                }
                if(code === 'STALE_CONTEXT'){
                    this.$message.warning('会员数据已变化，请刷新后重新确认');
                    this.finishSuccess(result, submit);
                    return;
                }
                if(code === 'INVALID_DATE' || code === 'INVALID_REMARK'){
                    this.$message.warning((result && result.message) || '输入不合法');
                    return;
                }
                if(code === 'INELIGIBLE' || code === 'NO_PERMISSION'){
                    this.$message.warning((result && result.message) || '当前不能办理');
                    this.pendingSubmit = null;
                    this.dialogVisible = false;
                    this.loadSuperVipContext(true);
                    return;
                }
                this.$message.warning((result && result.message) || '办理未完成，请稍后重试');
            },
            handleSubmitFailure(err, submit){
                if(!this.isCurrentSubmit(submit)){
                    return;
                }
                const isTimeout = !!err && (err.code === 'ECONNABORTED' || /timeout/i.test(err.message || ''));
                if(isTimeout && !submit.retried){
                    submit.retried = true;
                    this.loadSuperVipContext(true).then(ok=>{
                        if(!this.isCurrentSubmit(submit)){
                            return;
                        }
                        const decision = VipExtensionSubmit.decideAfterRead({
                            ok:ok,
                            current:this.isCurrentSubmit(submit),
                            compensated:this.superVip.compensated,
                            eligible:this.superVip.eligible,
                            snapshotToken:this.superVip.snapshotToken,
                            submit:submit
                        });
                        if(decision === 'already'){
                            this.$message.success('请求已成功，请勿重复办理');
                            this.finishSuccess(null, submit);
                            return;
                        }
                        if(decision === 'retry'){
                            this.$message.warning('请求超时，已确认会员状态未变化；正在使用同一请求号重试');
                            this.doSubmit(submit);
                            return;
                        }
                        if(decision === 'reconfirm'){
                            this.$message.warning('会员状态或快照已变化，请重新确认后再办理');
                            this.pendingSubmit = null;
                            this.loadSuperVipContext(true);
                            return;
                        }
                        this.$message.warning('回读会员状态失败，无法确认是否已办理；请刷新状态确认后再操作，请勿重复提交');
                    });
                    return;
                }
                this.$message.error((err && err.message) || '办理失败，请稍后重试；请勿重复提交');
            },
            finishSuccess(result, submit){
                if(!this.isCurrentSubmit(submit)){
                    return;
                }
                this.submitVersion += 1;
                this.dialogVisible = false;
                this.pendingSubmit = null;
                this.$emit('refresh-vip');
                this.loadSuperVipContext(true);
            },
            validateExtensionForm(){
                const date = this.extensionForm.newEndDate;
                if(!date){
                    return '请选择新到期日期';
                }
                if(!/^\d{4}-\d{2}-\d{2}$/.test(date)){
                    return '请选择合法的到期日期（yyyy-MM-dd）';
                }
                const selected = this.toShanghaiMillis(date);
                const original = this.toShanghaiMillis(this.superVip.originalEndTime);
                if(!isFinite(selected)){
                    return '请选择合法的到期日期';
                }
                if(isFinite(original) && selected <= original){
                    return '新到期时间必须晚于原最终到期时间';
                }
                if(selected <= Date.now()){
                    return '新到期时间必须晚于当前时间';
                }
                const remark = (this.extensionForm.remark || '').trim();
                const length = Array.from(remark).length;
                if(length < 1 || length > 255){
                    return '原因备注必填且为1-255字';
                }
                if(/[\uD800-\uDFFF]/.test(remark)){
                    return '原因备注包含数据库不支持的字符（如 emoji），请改用文字';
                }
                return '';
            },
            toShanghaiMillis(value){
                if(!value){
                    return NaN;
                }
                if(/^\d{4}-\d{2}-\d{2}$/.test(value)){
                    return Date.parse(value + 'T23:59:59+08:00');
                }
                if(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)){
                    return Date.parse(value.replace(' ','T') + '+08:00');
                }
                return Date.parse(value);
            },
            newRequestId(){
                if(window.crypto && typeof window.crypto.randomUUID === 'function'){
                    return window.crypto.randomUUID();
                }
                return 'req-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,10);
            },
            formatVipLogType(type){
                if(type !== null && type !== undefined &&
                    String(type).indexOf('FLOOD_SUPER_VIP_EXTENSION_V1') === 0){
                    return '会员补偿延期';
                }
                return type==0?'手工升级':(type==1?'订单升级':(type==2?'付费升级':'未知'))
            },
            returnHistory(){
                window.history.go(-1)
            },
            getVipLevelList(){
              this.$apiGet('lechun-mall/activeOrderApi/getPayVipList',{customerId:this.customerId}).then(()=>{
                this.vipProducts.put({
                  value:'1916723101176958976',
                  label:'典藏会员-199元年卡'
                })
                this.vipProducts.put({
                  value:'1916722952566607873',
                  label:'醇享会员-99元季卡'
                })
                this.vipProducts.put({
                  value:'1916722525246722048',
                  label:'鲜享会员-39元月卡'
                })
                // this.vipProducts = res.promotionList.map(item => {
                //     return {
                //         value: item.bindCode,
                //         label: item.promotionName
                //     }
                // });
              })
            },
            vipProductChange(bindCode){
              this.bindCode=bindCode;
            },
            formatDateTime(value){
              if(value === null || value === undefined || value === ''){
                return '-';
              }

              const text = String(value).trim();
              if(!text){
                return '-';
              }

              // 接口返回的 ISO 时间包含 T，统一转换为页面使用的可读格式。
              // 不通过 new Date 解析，避免浏览器时区转换导致日期发生偏移。
              const match = text.match(/^(\d{4}-\d{2}-\d{2})(?:[T\s]+(\d{2}:\d{2}(?::\d{2})?))?/);
              if(!match){
                return text;
              }

              return match[2] ? `${match[1]} ${match[2]}` : match[1];
            },
            initList(){
              
            },
            createVipOrder(){
              if(this.bindCode==''){
                this.$message({
                  type: 'warning',
                  message: '请选择会员级别'
                });
                return;
              }
              this.$apiGet('lechun-cms/activeManage/createVipOrder',{customerId:this.customerId,bindCode:this.bindCode}).then(res=>{
                this.$confirm('此操作不可撤销, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  if(res.status==6){
                      this.$message({
                      type: 'success',
                      message: '下单成功!'
                    });
                  }else{
                      this.$message({
                      type: 'info',
                      message: '失败，请检查余额是否充足'
                    });
                  }
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '失败'
                  });
                });

              })
            },
            customerLevelUp(){
              this.$apiGet('lechun-mall/vip/customerLevelUp',{customerId:this.customerId}).then(()=>{
                this.$confirm('此操作将重新计算会员等级, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$message({
                    type: 'success',
                    message: '计算成功!'
                  });
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '失败'
                  });
                });

              })
            },
            delCustomerVipCache(){
                this.$apiGet('lechun-customers/customer/deleteUserVipInfoCache',{customerId:this.customerId}).then(()=>{
                    this.$confirm('此操作将清除会员缓存, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '清除成功!'
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消清除'
                        });
                    });

                })
            },
            updateCustomerVipLevel(val){
                this.$apiGet('lechun-customers/customer/updateVipLevel',{customerId:this.customerId,level:val}).then(()=>{
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">

    .customer-detail-info{
        margin-top: 20px;
        .red .el-form-item__label{
            color: red;
        }
        .el-input{
            width: 100%;
            height: 32px;
        }
        .el-tag,.el-select{
            width: 100%;
            height: 32px;
        }

        .super-vip-extension{
            margin-bottom: 16px;
            padding: 14px 16px;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            background: #fafafa;
        }
        .super-vip-header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
        }
        .super-vip-title-wrap{
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
        }
        .super-vip-title{
            color: #303133;
            font-size: 14px;
            font-weight: 600;
        }
        .super-vip-name{
            color: #606266;
            font-size: 13px;
        }
        .super-vip-header .el-tag{
            width: auto;
            height: 22px;
            line-height: 20px;
            padding: 0 8px;
        }
        .super-vip-meta{
            display: flex;
            flex-wrap: wrap;
            gap: 8px 20px;
            margin-top: 10px;
            color: #606266;
            font-size: 13px;
        }
        .super-vip-alert{
            margin-top: 10px;
        }
        .extension-dialog-context{
            margin-bottom: 16px;
            padding: 10px 12px;
            border-radius: 4px;
            background: #f5f7fa;
            color: #606266;
            font-size: 13px;
            line-height: 24px;
        }
        .extension-label{
            color: #909399;
        }
        .extension-form{
            margin-top: 4px;
        }
        .extension-preview{
            margin-top: 12px;
            color: #303133;
            font-size: 13px;
            font-weight: 600;
        }
        .extension-expired-tip{
            margin-top: 8px;
            color: #e6a23c;
            font-size: 13px;
            line-height: 20px;
        }
    }
</style>
